import { render, staticRenderFns } from "./collaborators-list-view.vue?vue&type=template&id=38814295&scoped=true&"
import script from "./collaborators-list-view.vue?vue&type=script&lang=js&"
export * from "./collaborators-list-view.vue?vue&type=script&lang=js&"
import style0 from "./collaborators-list-view.vue?vue&type=style&index=0&id=38814295&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38814295",
  null
  
)

export default component.exports